import { FaBroadcastTower, FaWifi } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatNetworkSubtitle } from "./installationConfigUtils";
import { getPrimaryWifiCredential } from "./installationWifiUtils";
import { isMobileAkanthasAccount } from "../mobileModuleUtils";
import { InstallationPickerRow } from "./InstallationPickerSheet";

const InstallationConnectivitySection = ({
  routeCameraId,
  networkDetails,
  simProvider,
  configData,
  loading,
  disabled,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const showWifiConfig = isMobileAkanthasAccount();
  const configuredWifi = getPrimaryWifiCredential(configData);

  const openCellularDetail = () => {
    history.push(`/app/installationdetails/${routeCameraId}/state/cellular`, {
      networkDetails,
      simProvider,
    });
  };

  const openWifiConfig = () => {
    history.push(`/app/installationdetails/${routeCameraId}/state/wifi`);
  };

  return (
    <>
      <InstallationPickerRow
        icon={FaBroadcastTower}
        iconVariant="network"
        title={t("installation_state_network_label")}
        subtitle={
          loading
            ? t("installation_loading")
            : formatNetworkSubtitle(networkDetails, t)
        }
        onClick={openCellularDetail}
        disabled={loading || disabled}
      />
      {showWifiConfig && (
        <InstallationPickerRow
          icon={FaWifi}
          iconVariant="network"
          title={t("installation_wifi_row_title")}
          subtitle={
            configuredWifi?.ssid
              ? t("installation_wifi_row_subtitle_configured", {
                  ssid: configuredWifi.ssid,
                })
              : t("installation_wifi_row_subtitle_empty")
          }
          placeholder={t("installation_wifi_row_subtitle_empty")}
          onClick={openWifiConfig}
          disabled={loading || disabled}
          divided
          adminOnly
        />
      )}
    </>
  );
};

export default InstallationConnectivitySection;
